/**
 * Stable CSS class names for E2E — ScheduleCreate Query tab.
 */
export const SCQ = {
    root: 'schedule-query-tab',
    rows: 'schedule-query-tab__rows',
    row: 'schedule-query-tab__row',
    nameInput: 'schedule-query-tab-input__name',
    valueInput: 'schedule-query-tab-input__value',
    removeButton: 'schedule-query-tab-input--button-remove',
    removeIcon: 'schedule-query-tab__remove-icon',
    addButton: 'schedule-query-tab-input--button-add',
    addIcon: 'schedule-query-tab__add-icon',
    addText: 'schedule-query-tab__add-text',
} as const;

export const scqCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

